import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';

import { QueryParams } from '../../models/http.models';
import { Account } from '../account.models';

@Injectable({
  providedIn: 'root',
})
export class AccountResource {
  private apiRoot: string = `${process.env.API_URL}/accounts`;

  constructor(private http: HttpClient) {}

  get(account_id: string, params?: QueryParams): Observable<Account> {
    return this.http.get<Account>(`${this.apiRoot}/${account_id}`, { params });
  }

  save(body: Account, params?: QueryParams): Observable<Account> {
    return this.http.post<Account>(`${this.apiRoot}`, body, { params });
  }

  update(account_id: string, body: Account, params?: QueryParams): Observable<Account> {
    return this.http.put<Account>(`${this.apiRoot}/${account_id}`, body, { params });
  }

  remove(account_id: string, params?: QueryParams): Observable<any> {
    return this.http.delete<Account>(`${this.apiRoot}/${account_id}`, { params });
  }

  query(params?: QueryParams): Observable<Account[]> {
    return this.http.get<Account[]>(`${this.apiRoot}`, { params });
  }

  search(params?: QueryParams): Observable<Account[]> {
    return this.http.get<Account[]>(`${this.apiRoot}/search`, { params });
  }
}

((window as any).xplenty as angular.IModule).service('Account', downgradeInjectable(AccountResource));
